import { create } from 'zustand'

export interface ContactModalStore {
  isOpen: boolean
  onSuccessCallback?: () => void
  openModal: (onSuccess?: () => void) => void
  closeModal: () => void
}

export const useContactModalStore = create<ContactModalStore>((set) => ({
  isOpen: false,
  onSuccessCallback: undefined,
  
  openModal: (onSuccess?: () => void) => {
    set({
      isOpen: true,
      onSuccessCallback: onSuccess,
    })
  },
  
  closeModal: () => {
    set({
      isOpen: false,
      onSuccessCallback: undefined,
    })
  },
}))
